// used in notifications.component.html

// Angular
import {
    AfterViewInit,
    Component,
    EventEmitter,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store, select } from "@ngrx/store";

// RXJS/Store
import * as fromStore from "#login/store";
import * as studentStore from "#student/student-shared/store";
import { Observable } from "rxjs";

// Services/Types/Helpers
import { CoursePaginationParameters, NotificationService } from "@carnegie-learning/data-access-angular-passport";
import { Course, Notification } from "cli-types";

@Component({
    selector: "new-pm",
    templateUrl: "./new-pm.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./new-pm.component.scss",
    ],
    standalone: false
})
export class NewPmComponent implements OnInit, AfterViewInit {
    courses$: Observable<Course[]>;

    isTeacher?: Observable<boolean>;
    isStudent?: Observable<boolean>;
    confirmSent = false;
    loading = false;

    params: CoursePaginationParameters = {
        limit: 1000,
        page: 0,
        filter: { archived: false }, // true - only archived records, false - only active records, don't include param means everything
        search: "",
        sorting: { courseTitle: "asc" },
        // withCourseMetrics filter flag is slow, use with caution.
        withCourseMetrics: false,
        total: 0,
    };

    @Output() cancel = new EventEmitter<any>();
    @Output() goToInbox = new EventEmitter<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notificationService: NotificationService,
        private store_student: Store<studentStore.StudentCoursesState>,
        public store: Store<fromStore.UserState>
    ) {}

    ngOnInit() {
        this.isTeacher = this.store.pipe(select(fromStore.getIsTeacher));

        this.isStudent = this.store.pipe(select(fromStore.isStudent));

        this.loading = true;
        this.courses$ = this.store_student.pipe(
            select(studentStore.getAllStudentCourses)
        );
    }

    ngAfterViewInit() {}

    sendPm(event: Notification) {
        // format Dates for api
        this.loading = true;
        this.notificationService.sendPm(event).subscribe((response) => {
            this.confirmSent = true;
            this.loading = false;
        });
    }

    okay() {
        this.confirmSent = false;
        this.goToInbox.emit();
    }

    onClickCancel() {
        this.cancel.emit();
    }
}
